import { BarChart } from '@tremor/react';
import {WellsBar} from "../../hooks/useWellsOilfield";

const dataFormatter = (number: number) =>
	Intl.NumberFormat('us').format(number).toString();

export interface IBarChartUsageExampleProps {
		chartData: WellsBar[]
}
export function BarChartUsageExample({chartData}: IBarChartUsageExampleProps) {
		return (
			<div style={{width: "100%", display: "flex", gap: 16, alignItems: "flex-start"}}>
					<div style={{flex: 1, minWidth: 0}}>
						<BarChart
							data={chartData}
							style={{height: "65vh", width: "100%"}}
							index="name"
							yAxisWidth={48}
							categories={['cost']}
							colors={['blue']}
							valueFormatter={dataFormatter}
							showTooltip={true}
							showLegend={false}
							customTooltip={props => {
									return (
										<div style={{marginLeft: "-20px"}}>
												{props.label}: {props.payload && props.payload.length >= 1 ? props.payload[0].payload.price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""} USD
										</div>
									);
							}}
						>
						</BarChart>
					</div>
					<div style={{width: 180, flexShrink: 0, overflow: "auto", maxHeight: "65vh"}}>
							<table style={{ borderCollapse: "collapse", width: "100%", fontSize: 12 }}>
									<thead>
									<tr>
											<th style={{ border: "1px solid var(--border)", padding: "3px 6px", background: "var(--navy)", color: "#fff", position: "sticky", top: 0 }}>Name</th>
											<th style={{ border: "1px solid var(--border)", padding: "3px 6px", background: "var(--navy)", color: "#fff", position: "sticky", top: 0 }}>Price</th>
									</tr>
									</thead>
									<tbody>
									{chartData.map((value) => (
										<tr key={value.name}>
												<td style={{ border: "1px solid var(--border)", padding: "2px 6px" }}>{value.name}</td>
												<td style={{ border: "1px solid var(--border)", padding: "2px 6px", textAlign: "right" }}>{`${value.price.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}$`}</td>
										</tr>
									))}
									</tbody>
							</table>
					</div>
			</div>
		);
}
